import { useState } from "react";

const WELCOME_DIALOG_SEEN_KEY = "memetica_welcome_dialog_seen";

export function useWelcomeDialogState() {
  const [open, setOpen] = useState(() => {
    try {
      // Test if we can write to localStorage
      localStorage.setItem(
        WELCOME_DIALOG_SEEN_KEY,
        localStorage.getItem(WELCOME_DIALOG_SEEN_KEY) || ""
      );

      // Only show if we can confirm it's never been seen
      const hasSeenDialog = localStorage.getItem(WELCOME_DIALOG_SEEN_KEY);
      return hasSeenDialog === "";
    } catch {
      return false;
    }
  });

  const onClose = () => {
    try {
      localStorage.setItem(WELCOME_DIALOG_SEEN_KEY, "true");
    } catch {
      // Nothing we can do if we can't access local storage
    }
    setOpen(false);
  };

  return [open, onClose] as const;
}
